module.exports = __webpack_public_path__ + "img/parallax2-1440p.fc4a5705.jpg";